import { i18n } from '@/plugins/i18n'

export const useTranslation = () => {
  const { t } = i18n.global

  return t
}
